export default {
  locale: "en",
  name: "Configuration manager",
  translation: { displayName: "Translations" },
  fields: {
    list: [],
    form: [
      {
        fieldName: "useCustomEmailTemplate",
        displayName: "Use custom templates",
        description: "Activate this to allow the user to create their own templates",
        helpText: "If no template is created and active the default template will be used",
      },
      {
        fieldName: "pedircodigoseguridad",
        displayName: "Activate CCV field for PCIProxy",
        description: "Activates the CCV Field for the PCIProxy payment type",
        helpText:
          "Currently only works for PCI Proxy, could be expanded to other payment types in the future",
      },
      {
        fieldName: "activeAbandonmentCart",
        displayName: "Activate Cart Abandonment Email - LOYALTY",
        description: "Activate the cart abandonment email - LOYALTY",
        helpText: "LOYALTY when logging in",
      },
      {
        fieldName: "activeAbandonmentCartNotLoyalty",
        displayName: "Activate Cart Abandonment Email - NO LOYALTY",
        description: "Activate the cart abandonment email - NO LOYALTY",
        helpText: "NO LOYALTY when entering the guest's email address",
      },
      {
        fieldName: "useWebcampIntegration",
        description: "Use Webcamp integration",
        helpText: "If active, Webcamp will be used for availability management",
      },
      {
        fieldName: "keepMultiConfigOnRedirect",
        description: "Keep appearance when switching engine",
      },
      {
        fieldName: "preventRestrictiveRateCombinations",
        description: "Always apply the most restrictive rate",
      },
      {
        fieldName: "extrasCategoriesActive",
        description: "Activate extras with categories",
        helpText:
          "Enables extra categories (Vehicle, Facilities) on this property: limits and included amounts per accommodation type, charging only what exceeds the included amount, and a license plate per vehicle. When disabled, extras are sold as usual; whatever was configured is kept and applies again when re-enabled.",
      },
    ],
  },
};
